import vue from 'vue'
import vuex from 'vuex'

vue.use(vuex)

const state = {
	includePage: []
}
const getters = {
	includePage: state => state.includePage
}
const UPDATE_INCLUDE_PAGE = 'UPDATE_INCLUDE_PAGE'
const mutations = {
	[UPDATE_INCLUDE_PAGE](state,obj) {
		console.log("store"+obj)
		if(obj.flag) {
			state.includePage.push(obj.pageName)
		}else {
			state.includePage.splice(state.includePage.indexOf(obj.pageName), 1)
		}
	}
}
export default new vuex.Store({
	state,
	getters,
	mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js